import { render, staticRenderFns } from "./ProductOsCompatRelate.vue?vue&type=template&id=b5f48d3c"
import script from "./ProductOsCompatRelate.vue?vue&type=script&lang=js"
export * from "./ProductOsCompatRelate.vue?vue&type=script&lang=js"
import style0 from "./ProductOsCompatRelate.vue?vue&type=style&index=0&id=b5f48d3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports